import React from 'react';
import { Container, Card, CardBody, Table } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUsers, faFilePdf, faDownload } from '@fortawesome/free-solid-svg-icons';
import footerBg from "./../../assets/footerbg.jpg";
import esm from "./../../assets/ESMDefinition.pdf";
const Esm = () => {
  const data = [
    // { Force: 'CRPF',  Serving: '12903', Retired: '8345' },
    // { Force: 'ITBP',  Serving: '8279', Retired: '1490' },
    // { Force: 'SSB',  Serving: '3108', Retired: '70' },
    // { Force: 'CISF',  Serving: '5947', Retired: '3704' },
    // { Force: 'Assam Rifles',  Serving: '2278', Retired: '2343' },
    // { Force: 'BSF',  Serving: '-', Retired: '-' },
  ]
    return (
        <>
            <div style={{
                backgroundImage: `url(${footerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: '30px 0',
                color: 'white',
                margin: '2%',
                borderRadius: '10px'
            }}>
                <Container>
                    <h3 className="fw-bold mb-0 text-center">
                        <FontAwesomeIcon icon={faUsers} className="me-2" />
                        Ex-Servicemen in Haryana
                    </h3>
                </Container>
            </div>

            <Container className="py-5">
                <Card className="border-0 mb-4" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faFilePdf} className="me-2" />
                            Definition of ESM
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <a 
                            href={esm} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                        >
                            <div style={{
                                background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
                                color: 'white',
                                padding: '20px',
                                borderRadius: '15px',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '15px',
                                boxShadow: '0 8px 25px rgba(30,60,114,0.3)',
                                transition: 'all 0.3s ease'
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'scale(1.02)';
                                e.currentTarget.style.boxShadow = '0 12px 35px rgba(220,53,69,0.4)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'scale(1)';
                                e.currentTarget.style.boxShadow = '0 8px 25px rgba(220,53,69,0.3)';
                            }}
                            >
                                <div style={{
                                    background: 'rgba(255,255,255,0.2)',
                                    padding: '15px',
                                    borderRadius: '10px'
                                }}>
                                    <FontAwesomeIcon icon={faFilePdf} style={{ fontSize: '1.5rem' }} />
                                </div>
                                <div className="flex-grow-1">
                                    <h5 className="fw-bold mb-1">Definition of ESM</h5>
                                    <small style={{ opacity: 0.9 }}>Click to view document</small>
                                </div>
                                <FontAwesomeIcon icon={faDownload} style={{ fontSize: '1.2rem' }} />
                            </div>
                        </a>
                    </CardBody>
                </Card>

                <Card className="border-0" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 12px 40px rgba(30,60,114,0.15)' }}>
                    <div style={{
                        background: 'linear-gradient(135deg, #16a085 0%, #27ae60 100%)',
                        padding: '25px',
                        color: 'white'
                    }}>
                        <h4 className="fw-bold mb-0">
                            <FontAwesomeIcon icon={faUsers} className="me-2" />
                            ESM Personnel Data
                        </h4>
                    </div>
                    <CardBody className="p-4">
                        <div className="table-responsive">
                            <Table bordered hover className="mb-0">
                                <thead>
                                    <tr>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '10%' }}>Sr. No.</th>
                                        <th style={{ background: '#1e3c72', color: 'white', width: '40%' }}>Force Name</th>
                                        <th style={{ background: '#16a085', color: 'white', width: '25%' }}>Serving</th>
                                        <th style={{ background: '#8e44ad', color: 'white', width: '25%' }}>Retired</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.map((item, index) => (
                                        <tr key={index}>
                                            <td style={{ color: '#495057' }}>{index + 1}</td>
                                            <td style={{ color: '#1e3c72', fontWeight: '600' }}>{item.Force}</td>
                                            <td style={{ color: '#16a085', fontWeight: '600' }}>{item.Serving}</td>
                                            <td style={{ color: '#8e44ad', fontWeight: '600' }}>{item.Retired}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    {/* <tr style={{ background: '#f8f9fa' }}>
                                        <td style={{ color: '#495057' }}></td>
                                        <td style={{ color: '#1e3c72', fontWeight: 'bold' }}>Total</td>
                                        <td style={{ color: '#16a085', fontWeight: 'bold' }}>39718</td>
                                        <td style={{ color: '#8e44ad', fontWeight: 'bold' }}>12119</td>
                                    </tr> */}
                                </tfoot>
                            </Table>
                        </div>
                    </CardBody>
                </Card>
            </Container>
        </>
    );
};

export default Esm;
